import { Button } from "@/components/ui/Button";
import { useProfileContext } from "@/contexts/ProfileContext";
import { useLocation } from "react-router";

type Props = {
  prefix?: string;
  exclude?: "apple" | "google" | "facebook";
};

export default function FederatedAuth({ prefix = "Sign in", exclude }: Props) {
  const { authentication } = useProfileContext();
  const { pathname } = useLocation();
  return (
    <>
      <div className="relative text-center text-sm after:absolute after:inset-0 after:top-1/2 after:z-0 after:flex after:items-center after:border-t after:border-border">
        <span className="relative z-10 bg-brand-neutral-800 px-2 text-muted-foreground">
          Or continue with
        </span>
      </div>
      <div className="space-y-2">
        {exclude !== "apple" && (
          <Button
            type="button"
            variant="outline"
            className="w-full"
            onClick={() => {
              !authentication?.loggedIn &&
                authentication?.appleSignIn(pathname);
            }}
          >
            {prefix} with Apple
          </Button>
        )}
        {exclude !== "google" && (
          <Button
            type="button"
            variant="outline"
            className="w-full"
            onClick={() => {
              !authentication?.loggedIn &&
                authentication?.googleSignIn(pathname);
            }}
          >
            {prefix} with Google
          </Button>
        )}
        {exclude !== "facebook" && (
          <Button
            type="button"
            variant="outline"
            className="w-full"
            onClick={() => {
              !authentication?.loggedIn &&
                authentication?.facebookSignIn(pathname);
            }}
          >
            {prefix} with Facebook
          </Button>
        )}
      </div>
    </>
  );
}
